module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('h2', [_vm._v("Fale Conosco")]), _vm._v(" "), (!_vm.sent) ? [_c('p', [_vm._v("\n      Preencha o formulário abaixo para nos enviar uma mensagem.\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('name')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "seu nome"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-feedback",
    attrs: {
      "show": _vm.errors.has('name')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.email),
      expression: "model.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "seu e-mail"
    },
    domProps: {
      "value": (_vm.model.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-feedback",
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('message')
    }
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.message),
      expression: "model.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": "sua mensagem"
    },
    domProps: {
      "value": (_vm.model.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-feedback",
    attrs: {
      "show": _vm.errors.has('message')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-luna",
    attrs: {
      "disabled": _vm.sending,
      "type": "submit"
    }
  }, [_vm._v("Enviar")])])])] : [_c('p', [_vm._v("\n      Obrigado! Em breve você receberá nossa resposta.\n    ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baaca700","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 62
// module chunks = 0